// react
import { useState, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
// mui
import SpeedDial from "@mui/material/SpeedDial";
import MenuIcon from "@mui/icons-material/Menu";
import SpeedDialAction from "@mui/material/SpeedDialAction";
// components
import LockPopup from "src/components/UI/Home/Menu/LockPopup";
import user from "src/components/UI/Shared/user";
// icons
import login_icon from "src/components/UI/Home/Main/assets/images/login.png";
import lock_icon from "src/assets/images/lock-icon.png";
import layers_icon from "src/components/UI/Home/Main/assets/images/layers.png";
import toolbox_icon from "src/components/UI/Home/Main/assets/images/toolbox.png";
import sign_up_icon from "src/components/UI/Home/Main/assets/images/sign-up.png";
import log_out_icon from "src/components/UI/Home/Main/assets/images/logout.png";
// assets
import styles from "src/components/UI/Home/Main/assets/scss/burger-menu.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

const BurgerMenu = () => {
  const current_user = user.getCurrentLoggedIn();
  const actions = [
    {
      icon: <img src={layers_icon} alt="Layers" className={styles.icon} />,
      name: "Layers",
    },
    {
      icon: (
        <img
          src={current_user !== "guest" ? log_out_icon : login_icon}
          alt="Login"
          className={styles.icon}
          style={{
            left: current_user !== "guest" ? "" : "0.5rem",
            position: current_user !== "guest" ? "static" : "absolute",
          }}
        />
      ),
      name: current_user !== "guest" ? "Logout" : "Login",
    },
    {
      icon: (
        <img
          src={current_user !== "guest" ? lock_icon : sign_up_icon}
          alt="Register"
          className={styles.icon}
          style={{
            height: current_user !== "guest" ? "" : "1.325rem",
            width: current_user !== "guest" ? "" : "1.325rem",
            left: current_user !== "guest" ? "" : "0.625rem",
            position: current_user !== "guest" ? "static" : "absolute",
          }}
        />
      ),
      name: current_user !== "guest" ? "Lock" : "Register",
    },
    {
      icon: <img src={toolbox_icon} alt="Toolbox" className={styles.icon} />,
      name: "Toolbox",
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const activePanel = useSelector((state: any) => state.app.activePanel);
  const pickerModeEnabled = useSelector(
    (state: any) => state.app.pickerModeEnabled
  );

  const [open, setOpen] = useState(false);
  const [openVerificationPopup, setOpenVerificationPopup] = useState(false);
  const speedDialRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        speedDialRef.current &&
        event.target &&
        !(speedDialRef.current as any).contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const toggleSpeedDial = () => {
    setOpen(!open);
    if (pickerModeEnabled) {
      dispatch(appActions.setPickerModeEnabled(false));
    }
  };
  const handleToolboxClicked = () => {
    dispatch(appActions.setActivePanel("toolbox"));
    dispatch(
      appActions.setSearchString({
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        menu6: "",
      })
    );
    navigate("../../");
  };
  const handleLayersClicked = () => {
    navigate("layers");
  };
  const handleClickLock = () => {
    localStorage.setItem("locked", "locked");
    if (!localStorage.getItem("GiSimplifyLockCode")) {
      setOpenVerificationPopup(true);
    }
  };
  const handleCloseLockPopup = () => {
    setOpenVerificationPopup(false);
  };
  const handleSignOut = () => {
    user.signOut();
  };

  const handleClick = (actionName: string) => {
    if (actionName === "Layers") handleLayersClicked();
    else if (actionName === "Logout") {
      navigate("/");
      handleSignOut();
    } else if (actionName === "Login") navigate("/identity/login");
    else if (actionName === "Lock") {
      if (localStorage.getItem("GiSimplifyLockCode")) navigate("identity/lock");
      else handleClickLock();
    } else if (actionName === "Register") navigate("/identity/register");
    else if (actionName === "Toolbox") handleToolboxClicked();
  };
  return (
    <>
      <SpeedDial
        open={open}
        ref={speedDialRef}
        ariaLabel="burger-menu"
        className={styles.speedDial}
        icon={<MenuIcon />}
        onClick={toggleSpeedDial}
        direction="down"
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => {
              toggleSpeedDial();
              handleClick(action.name);
            }}
            className={styles.speedDialAction}
          />
        ))}
      </SpeedDial>
      {/* {openToolbox && <BasicCard />} */}

      {openVerificationPopup && (
        <LockPopup
          openModal={openVerificationPopup}
          onClose={handleCloseLockPopup}
        />
      )}
    </>
  );
};
export default BurgerMenu;
